export const getOptionsBySlug = (slug: string, optionsArray: Queries.OptionValuesFragmentFragment[]) => {
  return optionsArray?.filter(
    ({ option_type = [] }) => option_type?.length && option_type?.[0] && option_type?.[0].slug === slug
  );
};
